import ProjectHeroWeatherForecaster from "../../../components/ProjectHero/WeatherForecaster/ProjectHeroWeatherForecaster";
import ProjectDetailsWeatherForecaster from "../../../components/ProjectDetails/WeatherForecaster/ProjectDetailsWeatherForecaster";


function ProjectPageWeatherForecaster() {
    return (
        <>
            <ProjectHeroWeatherForecaster />
            <ProjectDetailsWeatherForecaster />
        </>
    )
}

export default ProjectPageWeatherForecaster;